import { Button, Tooltip } from "antd";
import { IconoEscudo, IconoCheck } from "./AuditIconos";

// AUDITORIA-CLINICA-REDISENO (FASE 2) -- pie de la tarjeta en modo edición.
// Dice explícitamente que la corrección NO destruye el registro del médico
// (es exactamente lo que hace el backend: `before_json` queda guardado en
// `clinical_audit_correction_details`), y concentra las dos únicas salidas.
//
// "Guardar corrección" se deshabilita mientras falte algo, pero NUNCA sin
// explicación: el tooltip y el texto del pie dicen qué falta.
function AtencionSeccionPie({ motivoNoGuardable, guardando, onCancelar, onGuardar }) {
    return (
        <div className="ac-edicion__pie" data-testid="ac-edicion-pie">
            <IconoEscudo />
            <span data-testid="ac-edicion-motivo">
                {motivoNoGuardable ||
                    "La versión original se conserva en el historial. Esta corrección no borra el registro del médico."}
            </span>
            <div className="ac-edicion__pie-acciones">
                <Button onClick={onCancelar} disabled={guardando} data-testid="ac-edicion-cancelar">
                    Cancelar
                </Button>
                <Tooltip title={motivoNoGuardable || null}>
                    <span>
                        <Button
                            type="primary"
                            icon={<IconoCheck />}
                            loading={guardando}
                            disabled={!!motivoNoGuardable}
                            onClick={onGuardar}
                            data-testid="ac-edicion-guardar"
                        >
                            Guardar corrección
                        </Button>
                    </span>
                </Tooltip>
            </div>
        </div>
    );
}

export default AtencionSeccionPie;
